import React, { useRef, useState } from "react";
import propTypes from "prop-types";
import ArrowDownIm from "../../assets/Icons/Sidebar/ArrowDown.svg";

const NavNestedMenu = ({ children, title, icon }) => {
  const subMenu = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const handelToggleMenue = (e) => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <li style={style} onClick={handelToggleMenue}>
        <span style={navItemStyle}>
          <img
            src={icon}
            alt=""
            style={{ width: "1.5rem", height: "1.1rem" }}
          />
          <span>{title}</span>
        </span>

        <button
          className={isOpen ? "dropDownArrowBtnDown" : "dropDownArrowBtnUp"}
        >
          <img src={ArrowDownIm} alt="" />
        </button>
      </li>
      <ul
        className="nestedDropDown"
        style={{
          height: isOpen ? `${subMenu.current?.children.length * 3}rem` : 0,
        }}
        ref={subMenu}
      >
        {children}
      </ul>
    </>
  );
};

NavNestedMenu.propTypes = {
  children: propTypes.node.isRequired,
  title: propTypes.string.isRequired,
  icon: propTypes.element.isRequired,
  isOpen: propTypes.bool.isRequired,
  toggleMenu: propTypes.func.isRequired,
};

export default NavNestedMenu;

const style = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "2rem",
  cursor: "pointer",
  paddingRight: "0.7rem",
};

const navItemStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "1.5rem",
  fontSize: "16px",
};
